import { descriptionStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsDescription";
// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { nonStockFormStyles } from "@sc/App/Widgets/NonStockRfqForm/NonStockRfqForm";
import Plus from "@sc/XDL/Icons/Plus";
import { IconWrapper } from "@insite/mobius/Icon";
import Remove from "@sc/XDL/Icons/Remove";
import { color, createLinkIconStyles, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

nonStockFormStyles.submitWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        margin-top: 16px;
    `,
};

nonStockFormStyles.infoWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 22px;
        margin-bottom: 16px;
    `,
};

nonStockFormStyles.infoTextSmallHeading = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                width: auto;
            `,
        },
        heading: {
            size: 14,
            lineHeight: "19px",
        },
        text: {
            size: 14,
            lineHeight: "19px",
        },
    }),
};

nonStockFormStyles.textFieldsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        column-gap: 22px;
        row-gap: 16px;
    `,
};

nonStockFormStyles.sharedTextFieldStyles = {
    css: css`
        width: calc(50% - 11px);
        ${xScreen("lte", 767)} {
            width: 100%;
        }
    `,
};

nonStockFormStyles.separator = {
    css: css`
        width: 100%;
        height: 1px;
        border-top: 1px solid ${color("common.border")};
        margin: 16px auto;
    `,
};

nonStockFormStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 20px;
    `,
};

nonStockFormStyles.linesHeader = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        border-radius: 4px;
        background: ${color("common.ui2")};
        border: 1px solid ${color("common.border")};
        ${xScreen("lte", 767)} {
            display: none;
        }
    `,
};

const sharedHeaderStyles = {
    css: css`
        padding: 9px 13px;
        font-size: 12px;
        font-weight: bold;
        line-height: 14px;
    `,
};

nonStockFormStyles.mfrName = {
    css: css`
        ${sharedHeaderStyles.css}
        border-right: 1px solid ${color("common.border")};
        width: 30%;
    `,
};

nonStockFormStyles.mfrNum = {
    css: css`
        ${sharedHeaderStyles.css}
        border-right: 1px solid ${color("common.border")};
        width: 20%;
    `,
};

nonStockFormStyles.itemDescription = {
    css: css`
        ${sharedHeaderStyles.css}
        border-right: 1px solid ${color("common.border")};
        width: 45%;
    `,
};

nonStockFormStyles.descriptionField = {
    css: css`
        width: 45%;
        padding-inline: 13px;
        ${xScreen("lte", 767)} {
            width: 100%;
            padding: 0;
        }
    `,
};

nonStockFormStyles.mfrNameField = {
    css: css`
        width: 30%;
        padding-inline: 13px;
        ${xScreen("lte", 767)} {
            width: 100%;
            padding: 0;
        }
    `,
};

nonStockFormStyles.mfrNumField = {
    css: css`
        width: 20%;
        padding-inline: 13px;
        ${xScreen("lte", 767)} {
            width: 100%;
            padding: 0;
        }
    `,
};

nonStockFormStyles.lineWrapper = {
    css: css`
        display: flex;
        flex-wrap: nowrap;
        padding-top: 12px;
        ${xScreen("lte", 767)} {
            flex-direction: column;
            flex-wrap: wrap;
            gap: 16px;
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 16px;
        }
    `,
};

nonStockFormStyles.notesWrapper = {
    css: css`
        margin-top: 16px;
    `,
};

nonStockFormStyles.addItemLink = {
    ...createLinkIconStyles(Plus, {
        css: css`
            margin-left: auto;
            margin-top: 16px;
            display: block;
        `,
    }),
};
nonStockFormStyles.remove = {
    ...createLinkIconStyles(Remove, {
        icon: {
            iconProps: {
                css: css`
                    margin-right: 0;
                `,
            },
        },
        css: css`
            flex-grow: 1;
            justify-content: center;
            align-items: flex-start;
            margin-top: 11px;
            &&:hover > ${IconWrapper} {
                color: ${color("common.ui8")};
            }
            ${xScreen("lte", 767)} {
                position: absolute;
                right: 16px;
                margin-top: 0;
            }
        `,
    }),
};
nonStockFormStyles.errorMsg = {
    css: css`
        margin-top: 16px;
    `,
};
nonStockFormStyles.heading = {
    css: css`
        &,
        p {
            font-size: 18px;
            font-weight: bold;
            line-height: 24px;
        }
    `,
};
nonStockFormStyles.subHeading = {
    css: css`
        &,
        p {
            font-size: 16px;
        }
    `,
};
